function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Reporting");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon-reporting",
  transform: "translate(-2.000000, 0.000000)"
}, React.createElement("g", {
  id: "noun_clipboard_1830858-copy-3",
  opacity: 0.7,
  transform: "translate(2.000000, 0.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M11.625,-7.21909393e-08 L0.375,-7.21909393e-08 C0.275525515,-7.21909393e-08 0.180108084,0.0420585523 0.109768988,0.117086921 C0.0394298927,0.19211529 -6.76790063e-08,0.293893882 -6.76790063e-08,0.4 L-6.76790063e-08,15.6 C-6.76790063e-08,15.7061061 0.0394298927,15.8078847 0.109768988,15.8829131 C0.180108084,15.9579414 0.275525515,15.9999999 0.375,15.9999999 L11.625,15.9999999 C11.7244745,15.9999999 11.8198919,15.9579414 11.890231,15.8829131 C11.9605701,15.8078847 11.9999999,15.7061061 11.9999999,15.6 L11.9999999,0.4 C11.9999999,0.293893882 11.9605701,0.19211529 11.890231,0.117086921 C11.8198919,0.0420585523 11.7244745,-7.21909393e-08 11.625,-7.21909393e-08 Z M7.5,0.8 L7.5,1.6 L4.5,1.6 L4.5,0.8 L7.5,0.8 Z M11.25,15.2 L0.75,15.2 L0.75,0.8 L3.75,0.8 L3.75,2 C3.74994026,2.10610612 3.78942989,2.20788471 3.85976899,2.28291308 C3.93010808,2.35794145 4.02552551,2.40006372 4.125,2.4 L7.875,2.4 C7.97447449,2.40006372 8.06989192,2.35794145 8.14023101,2.28291308 C8.21057011,2.20788471 8.25005974,2.10610612 8.25,2 L8.25,0.8 L11.25,0.8 L11.25,15.2 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M2.625,4.8 C2.41789322,4.8 2.25,4.9790861 2.25,5.2 C2.25,5.4209139 2.41789322,5.6 2.625,5.6 L9.375,5.6 C9.58210678,5.6 9.75,5.4209139 9.75,5.2 C9.75,4.9790861 9.58210678,4.8 9.375,4.8 L2.625,4.8 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M9.375,7.2 L2.625,7.2 C2.41789322,7.2 2.25,7.3790861 2.25,7.6 C2.25,7.8209139 2.41789322,8 2.625,8 L9.375,8 C9.58210678,8 9.75,7.8209139 9.75,7.6 C9.75,7.3790861 9.58210678,7.2 9.375,7.2 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M9.375,9.6 L2.625,9.6 C2.41789322,9.6 2.25,9.7790861 2.25,10 C2.25,10.2209139 2.41789322,10.4 2.625,10.4 L9.375,10.4 C9.58210678,10.4 9.75,10.2209139 9.75,10 C9.75,9.7790861 9.58210678,9.6 9.375,9.6 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M9.375,12 L2.625,12 C2.41789322,12 2.25,12.1790861 2.25,12.4 C2.25,12.6209139 2.41789322,12.8 2.625,12.8 L9.375,12.8 C9.58210678,12.8 9.75,12.6209139 9.75,12.4 C9.75,12.1790861 9.58210678,12 9.375,12 Z",
  id: "Path"
}))), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#979797",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15
})));

const SvgRenewalsReporting = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRenewalsReporting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/renewals-reporting.433cd915.svg";
export { ForwardRef as ReactComponent };